import React from 'react';

import uuid from 'uuid';

import animated_spoiler from '../../../../../custom_js/animated_spoiler';

export function RollUpClickableTitle({ title = 'Програма' } = {}) {
  const jsClassUnrollTextByTitle = 'a-' + uuid()

  return (
    <div
      className={`sertificat__title ${jsClassUnrollTextByTitle}`}
      onClick={() =>
        animated_spoiler({
          tagSelector: '.' + jsClassUnrollTextByTitle,
          contentSelector: '.sertificat__text'
        })
      }
    >
      {title}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/item/RollUpClickableTitle.jsx